(function($, undefined) {
	
	'use strict';
	var form;
	var popup;
	
	var processNewSave = function () {
		var t = $(this);
		var currForm = t.closest('.saves-add-form');
		var currPopup = t.closest('.saves-form-popup');
		
		form.validateForm(currForm);
		
		if (!currForm.hasClass('has-error')) {
			currPopup.addClass('is-processing');
			
			createNewSave($('.form-input[name="title"]', currForm).val(), $('input[name="personId"]', currForm).val(), $('input[name="id"]', currForm).val(), function(response) {
				window.location.href = window.location.href;
			});
		}
	};
	
	var createNewSave = function (title, personId, id, callback) {
		var data = {
			field1: 'save',
			field2: title,
			field9: personId,
			friendlyUrlField: 'field2',
			ajax: true
		};
		
		//Last edit date
		data.dateField2Year = new Date().getFullYear();
		data.dateField2Month = new Date().getMonth();
		data.dateField2Day = new Date().getDate();
		data.dateField2Hour = new Date().getHours();
		data.dateField2Minute = new Date().getMinutes();
		data.dateField2Second = new Date().getSeconds();
		
		if (id.length) {
			data.id = id;
		} else {
			//Creation date
			data.dateField1Year = new Date().getFullYear();
			data.dateField1Month = new Date().getMonth();
			data.dateField1Day = new Date().getDate();
			data.dateField1Hour = new Date().getHours();
			data.dateField1Minute = new Date().getMinutes();
			data.dateField1Second = new Date().getSeconds();
		}
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: data,
			method: 'POST',
			success: function (response) {
				console.log('saves new/edit : ' + response);
				
				if (typeof callback === 'function') {
					callback(response);
				}
			}
		});
	};
	
	var delSave = function () {
		var t = $(this);
		var currPopup = t.closest('.demo-action-form');
		var id = t.attr('data-item-id');
		
		currPopup.addClass('is-processing');
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: id,
				delete: true,
				ajax: true
			},
			method: 'POST',
			success: function (response) {
				console.log('saves delete : ' + response);
				window.location.href = window.location.href;
			}
		});
	};
	
	var removeFromSave = function () {
		var t = $(this);
		var id = t.attr('data-item-id');
		var item = $('.save-demo-list-item[data-id="'+id+'"]');
		var saveId = $('.save-single-info').attr('data-id');
		
		popup.closeAllPopup();
		
		item.slideUp(200, function () {
			item.remove();
			var newArray = '';
			
			$('.save-demo-list-item').each(function () {
				if (newArray !== '') {
					newArray += ',';
				}
				
				newArray += $(this).attr('data-id');
			});
			
			
			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: saveId,
					field3: newArray,
					ajax: true
				},
				success: function (response) {
					console.log('Remove from list : ' + response);
				}
			});
		});
	};
	
	var init = function () {
		popup = Fw.component.models().popup;
		form = Fw.component.models().form;

		$('body').on('click', '.saves-add-form-submit', processNewSave);
		$('body').on('click', '.saves-action-form-submit', delSave);
		$('body').on('click', '.artists-com-remove-from-save-confirm', removeFromSave);
	};
	
	$(window).ready(function () {
		init();
	});
	
	Fw.page.export('saves', {
		createNewSave: createNewSave
	})
	
})(jQuery);
